/**
 * Article
 */
// Module dependencies
import 'protons';
// Module template
import './_article.twig';

export const name = 'article';
export function disable() {}
export function enable() {}
export default enable;
